/**
 * 👥 オーディエンス Hub (v3.3 IA 刷新で新設)
 *
 * 統合対象:
 *   - mail.contacts (配信先 / グループ 内部タブを Hub レベルへ昇格)
 *   - marketing.leads (旧マーケティング・リード画面を統合)
 *   - line.users (LINE フォロワー一覧)
 *
 * 余白統一: 他 Hub と同様、外側 Screen は使わず各タブ render 関数が
 * Screen でラップする。ContactsTab / GroupsTab は元々 Screen を持たないため
 * 個別に Screen でラップして screen-body padding を確保する。
 */
import { Screen } from '@/components/layout/Screen';
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { ContactsTab } from '@/pages/mail/contacts/ContactsTab';
import { GroupsTab } from '@/pages/mail/contacts/GroupsTab';
import { LeadsPage } from '@/pages/marketing/leads/LeadsPage';
import { UsersPage as LineUsersPage } from '@/pages/line/users/UsersPage';

const TABS: TabSpec[] = [
  {
    tabKey: 'contacts',
    label: 'メール配信先',
    featureId: 'mail.contacts',
    render: () => (
      <Screen
        title="メール配信先"
        description="メール配信対象の連絡先一覧。CSV 取込・手動追加に対応"
      >
        <ContactsTab />
      </Screen>
    ),
  },
  {
    tabKey: 'groups',
    label: 'グループ',
    featureId: 'mail.contacts',
    render: () => (
      <Screen
        title="グループ"
        description="配信先連絡先のグループ管理。AI グルーピング/手動グルーピングに対応"
      >
        <GroupsTab />
      </Screen>
    ),
  },
  { tabKey: 'leads', label: 'リード',        featureId: 'marketing.leads', render: () => <LeadsPage /> },
  { tabKey: 'line',  label: 'LINEフォロワー', featureId: 'line.users',      render: () => <LineUsersPage /> },
];

export function AudienceHubPage() {
  return <HubTabs tabs={TABS} defaultTab="contacts" />;
}
